import { Flex } from '@alpine-iq/ui-library';
import React from 'react';

export interface LayoutProps {
	children: React.ReactNode;
	style?: React.CSSProperties;
}

export default function Layout({ children, style }: React.PropsWithChildren<LayoutProps>) {
	return (
		<section
			css={`
				* {
					box-sizing: border-box;
				}
			`}
			style={style}
		>
			{children}
		</section>
	);
}

export function SettingsPageLayout({ children }: React.PropsWithChildren<LayoutProps>) {
	return (
		<Flex
			column
			gap={24}
			css={{
				minHeight: 350,
				maxWidth: 700,
				width: '100%',
			}}
		>
			{children}
		</Flex>
	);
}
